import { PageBuilder } from '@web-app/layout';

import { Box, Icon, LinkTranslatedStyledAsLink, Typography } from '@core/component';
import { useContextMediaQuery } from '@core/context';
import { EColor, EFontWeight, EIcon, ERouting, ESize, ETypographyVariant } from '@core/type';
import { SanityBlogArticle, SanityWidget } from '@core/type/sanity';

import { BlogSocialLinks } from '../BlogSocialLinks';

export const BlogArticleContent = ({
  title,
  subtitle,
  body: { tags, pageBuilder },
  pageId,
}: SanityBlogArticle & { pageId: string }) => {
  const { isPhone, isDesktop } = useContextMediaQuery();

  return (
    <>
      <Typography
        variant={ETypographyVariant.BODY1}
        marginBottom={'32px'}
        fontWeight={EFontWeight.BOLD}
      >
        {subtitle}
      </Typography>

      <PageBuilder components={pageBuilder as SanityWidget[]} pageId={pageId} />

      <Box
        marginTop={'32px'}
        paddingBottom={'8px'}
        display={'flex'}
        alignItems={'center'}
        gap={'12px'}
        justifyContent={isPhone ? 'center' : 'flex-start'}
      >
        {tags?.length > 0 && <Icon type={EIcon.TAG} size={ESize.MD} color={EColor.ACCENT} />}
        {tags?.map(({ pageSlug: { slug }, title }) => (
          <LinkTranslatedStyledAsLink
            key={slug.current}
            keyRoute={ERouting.BLOG_TAG}
            query={{ slug: slug.current }}
            color={EColor.ACCENT}
          >
            {title}
          </LinkTranslatedStyledAsLink>
        ))}
      </Box>

      {!isDesktop && (
        <Box
          display={'flex'}
          gap={'24px'}
          flexDirection={'row'}
          marginTop={'32px'}
          justifyContent={isPhone ? 'center' : 'flex-start'}
        >
          <BlogSocialLinks title={title} subtitle={subtitle} />
        </Box>
      )}
    </>
  );
};
